export const getLocationName = startup => startup.attributes.LOC.data.attributes.name
